// Rótulos pt-BR dos alérgenos (ANVISA RDC 26/2015) e dos nutrientes (RDC 429/2020) para exibição no cardápio.
// O backend envia CÓDIGOS estáveis (GLUTEN, LEITE, …); a UI traduz aqui. Fase 7.1.
import type { Nutricional } from './api';

export const ALERGENO_ROTULO: Record<string, string> = {
  GLUTEN: 'glúten',
  CRUSTACEOS: 'crustáceos',
  OVOS: 'ovos',
  PEIXES: 'peixes',
  AMENDOIM: 'amendoim',
  SOJA: 'soja',
  LEITE: 'leite',
  CASTANHAS: 'castanhas',
  LATEX: 'látex',
};

/** Traduz códigos de alérgeno em rótulos pt-BR; um código desconhecido cai no próprio texto em minúsculas. */
export function rotulosAlergenos(codigos: string[]): string[] {
  return codigos.map((c) => ALERGENO_ROTULO[c] ?? c.toLowerCase());
}

/** Uma linha da tabela nutricional a exibir: rótulo, valor e unidade. Ordem oficial do rótulo nutricional. */
export interface LinhaNutricional {
  rotulo: string;
  valor: number;
  unidade: string;
}

interface CampoNutricional {
  chave: keyof Nutricional;
  rotulo: string;
  unidade: string;
}

// Ordem e rótulos conforme a tabela de rotulagem nutricional (energia primeiro, depois macros, sódio ao fim).
const CAMPOS: CampoNutricional[] = [
  { chave: 'valorEnergeticoKcal', rotulo: 'Valor energético', unidade: 'kcal' },
  { chave: 'carboidratosG', rotulo: 'Carboidratos', unidade: 'g' },
  { chave: 'acucaresTotaisG', rotulo: 'Açúcares totais', unidade: 'g' },
  { chave: 'acucaresAdicionadosG', rotulo: 'Açúcares adicionados', unidade: 'g' },
  { chave: 'proteinasG', rotulo: 'Proteínas', unidade: 'g' },
  { chave: 'gordurasTotaisG', rotulo: 'Gorduras totais', unidade: 'g' },
  { chave: 'gordurasSaturadasG', rotulo: 'Gorduras saturadas', unidade: 'g' },
  { chave: 'gordurasTransG', rotulo: 'Gorduras trans', unidade: 'g' },
  { chave: 'fibraAlimentarG', rotulo: 'Fibra alimentar', unidade: 'g' },
  { chave: 'sodioMg', rotulo: 'Sódio', unidade: 'mg' },
];

/** Formata "por porção" a partir de porcaoG + medida caseira; null se nenhum dos dois foi informado. */
export function porcaoTexto(n: Nutricional): string | null {
  const partes: string[] = [];
  if (n.porcaoG != null) partes.push(`${n.porcaoG.toLocaleString('pt-BR')} g`);
  if (n.medidaCaseira) partes.push(n.medidaCaseira);
  return partes.length ? partes.join(' · ') : null;
}

/** Linhas da tabela nutricional que têm valor (só o que foi preenchido aparece). */
export function linhasNutricional(n: Nutricional): LinhaNutricional[] {
  const linhas: LinhaNutricional[] = [];
  for (const campo of CAMPOS) {
    const valor = n[campo.chave];
    if (typeof valor === 'number') {
      linhas.push({ rotulo: campo.rotulo, valor, unidade: campo.unidade });
    }
  }
  return linhas;
}
